import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { useDispatch } from "react-redux";
import { changePassword } from "../../features/auth/authSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ChangePassword = (props) => {
  const { setShowModal } = props;

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const decodedToken = useDecodedToken();

  const [errors, setErrors] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");

  const [oldPassword, setOldShowPassword] = useState(false);
  const [newPassword, setNewShowPassword] = useState(false);
  const [conPassword, setConShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (formData.new_password !== formData.confirm_password) {
      setErrors({ confirm_password: "Passwords do not match" });
      return;
    }

    const clientData = {
      user_id: decodedToken?.UsrId,
      old_password: formData.old_password,
      new_password: formData.new_password,
      confirm_password: formData.confirm_password,
    };

    dispatch(changePassword(clientData))
      .unwrap()
      .then((result) => {
        if (result.status) {
          toast.success(result.message);

          setFormData({
            old_password: "",
            new_password: "",
            confirm_password: "",
          });

          setErrors({});
          setErrorData([]);
          setLoginError("");

          if (setShowModal) setShowModal(false);
        } else {
          setLoginError(result.message || "Something went wrong");
          setErrorData(result.form_err || []);
        }
      })
      .catch((err) => {
        setLoginError(err?.message || "Error occurred");
        setErrorData(err?.form_err || []);
        toast.error(err?.message || "Error occurred");
      });
  };

  // ✅ MAP ERRORS
  const mapErrors = (errorData) => {
    const errorMap = {};

    (errorData || []).forEach((error) => {
      if (!errorMap[error.param]) {
        errorMap[error.param] = error.msg;
      }
    });

    return errorMap;
  };
  useEffect(() => {
    setErrors(mapErrors(errorData));
  }, [errorData]);
  const handleTogglePassword = () => setOldShowPassword((prev) => !prev);

  const handleToggleNewPassword = () => setNewShowPassword((prev) => !prev);

  const handleToggleConPassword = () => setConShowPassword((prev) => !prev);
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Settings </h4>

            {/* <div className="page-title-right">
              <Breadcrumbs />
            </div> */}
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-6">
          <div className="card shadow-sm">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Change Password</h5>

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleBack}
              >
                ← Back
              </Button>
            </div>
            <div className="card-body">
              <label className="form-label mb-2">Old Password:</label>
              <div className="position-relative mb-3">
                <input
                  type={oldPassword ? "text" : "password"}
                  className="form-control pe-5"
                  name="old_password"
                  placeholder="Enter Old Password"
                  value={formData.old_password}
                  onChange={handleChange}
                  autoComplete="off"
                />

                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 text-muted"
                  onClick={handleTogglePassword}
                >
                  <i
                    className={`ri-${oldPassword ? "eye-off-fill" : "eye-fill"}`}
                  ></i>
                </button>

                {errors.old_password && (
                  <div className="text-danger">{errors.old_password}</div>
                )}
              </div>
              <label className="form-label mb-2">New Password:</label>
              <div className="position-relative mb-3">
                <input
                  type={newPassword ? "text" : "password"}
                  className="form-control pe-5"
                  name="new_password"
                  placeholder="Enter New Password"
                  value={formData.new_password}
                  onChange={handleChange}
                  autoComplete="off"
                />

                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 text-muted"
                  onClick={handleToggleNewPassword}
                >
                  <i
                    className={`ri-${newPassword ? "eye-off-fill" : "eye-fill"}`}
                  ></i>
                </button>

                {errors.new_password && (
                  <div className="text-danger">{errors.new_password}</div>
                )}
              </div>
              <label className="form-label mb-2">Confirm Password:</label>
              <div className="position-relative mb-3">
                <input
                  type={conPassword ? "text" : "password"}
                  className="form-control pe-5"
                  name="confirm_password"
                  placeholder="Enter Confirm Password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  autoComplete="off"
                />

                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 text-muted"
                  onClick={handleToggleConPassword}
                >
                  <i
                    className={`ri-${conPassword ? "eye-off-fill" : "eye-fill"}`}
                  ></i>
                </button>

                {errors.confirm_password && (
                  <div className="text-danger">{errors.confirm_password}</div>
                )}
              </div>
              <div className="d-flex justify-content-end">
                <Button
                  variant="success"
                  onClick={handleSubmit}
                  disabled={
                    !formData.old_password ||
                    !formData.new_password ||
                    !formData.confirm_password
                  }
                >
                  Update
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
